import { Component, Inject, inject } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { NgClass, NgIf } from '@angular/common';
import { CommanService } from '../../shared/utils/comman.service';
import { FieldErrorDisplayComponent } from '../../shared/components/field-error-display/field-error-display.component';
import { NotificationService } from '../../shared/utils/notification.service';
import { MustMatch } from '../../shared/utils/compare';
import { Subscription } from 'rxjs';
import { LoaderService } from '../../services/loader/loader.service';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [ReactiveFormsModule, RouterModule, FieldErrorDisplayComponent, NgClass, NgIf],
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'] // Fixed: should be styleUrls
})
export class ForgotPasswordComponent {
  showNewPassword: any;
  showConfirmPassword: any;
  subscription: Subscription;
  forgotPasswordForm: FormGroup;
  otpFlag: boolean = false;
  commonService = inject(CommanService);
  authService = inject(AuthService);
  router = inject(Router);
  loaderService = inject(LoaderService)
  notificationService = inject(NotificationService)
  constructor(private fb: FormBuilder) {
    this.subscription = new Subscription();
    this.forgotPasswordForm = this.fb.group({
      Phone: ['', Validators.required],
      password: ['', this.otpFlag ? [Validators.required] : ''],
      confirmPassword: ['', this.otpFlag ? [Validators.required] : ''],
      otp: ['', this.otpFlag ? [Validators.required] : '']
    }, { validator: MustMatch('password', 'confirmPassword') });



  }

  ngOnInit() {
    this.loaderService.setLoggedInStatus(false);
   }
  /*
    *   function name: isFieldValid()
    *   functionality: To check if all the form fields are valid  
    *   parameters : field
    */
  public isFieldValid(field: string) {
    let result = this.commonService.isFormFieldValid(field, this.forgotPasswordForm);
    return result;
  }

  /*
*   function name: displayFieldCss()
*   functionality: To display error class if validation fails  
*   parameters : field
*/
  public displayFieldCss(field: string) {
    let result = this.commonService.displayFieldCss(field, this.forgotPasswordForm);
    return result;
  }

  /*
   *   function name: doLogin()
   *   functionality: To login into the application  
   *   parameters : none
   */
  public forgotPasswordFormSubmit() {
    if (this.forgotPasswordForm.valid) {
      let formData = this.forgotPasswordForm.value;
      this.subscription = this.authService.forgotPassword(formData).subscribe((data: any) => {
        let response: any = data;
        if (response.code == 200) {
          this.router.navigate(['/login']);
          this.notificationService.notification('success', response.message, "", null);

        } else {
          this.notificationService.notification('danger', response.message, "", null);
        }
      },
        err => {
          this.notificationService.notification('danger', err.message, '', null);
        });
    } else {
      this.commonService.validateAllFormFields(this.forgotPasswordForm,"Validation Error");
    }
  }
  sendOTP() {
    if (this.forgotPasswordForm.valid) {
      this.otpFlag = true;
      let formData = this.forgotPasswordForm.value;
      this.subscription = this.authService.getOtp(formData).subscribe((data: any) => {
        let response: any = data;
        if (response.code == 200) {
          this.notificationService.notification('success', response.message, "", null);
        } else {
          this.notificationService.notification('danger', response.message, "", null);
        }
      },
        err => {
          this.notificationService.notification('danger', err.message, '', null);
        });
    } else {
      this.commonService.validateAllFormFields(this.forgotPasswordForm,"Validation Error");
    }
  }




  // Toggle visibility for New Password
  public toggleNewPasswordVisibility(): void {
  //this.showNewPassword = !this.showNewPassword;
  }

  // Toggle visibility for Confirm Password

  public toggleConfirmPasswordVisibility(): void {
    //this.showConfirmPassword = !this.confirmPassword;
  }

}
